import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from 'src/app/services/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private snackBar: MatSnackBar, private notificationService: NotificationService,) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage;
        if (error.error instanceof ErrorEvent) {
          errorMessage = "Network error: Please check your internet connection.";
        } else {
          switch (error.status) {
            case 0:
              errorMessage = "Network error: Unable to connect to the server.";
              break;
            case 400:
              errorMessage = "Bad request. Please verify your input.";
              break;
            case 401:
              errorMessage = "Unauthorized access. Please log in.";
              break;
            case 403:
              errorMessage = "Access forbidden. You don’t have permission to access this resource.";
              break;
            case 404:
              errorMessage = "Resource not found. Please check the URL.";
              break;
            case 500:
              errorMessage = "Server error. Please try again later.";
              break;
            default:
              if (error.error && error.error.Message) {
                errorMessage = error.error.Message;
              }
          }
        }
        this.notificationService.showError(errorMessage)
        return throwError(error);
      })
    );
  }
}
